<template>
  <div class="no-permission">
    <h1>您没有访问此页面的权限</h1>
  </div>
</template>

<script>
export default {
  name: 'NoPer'
}
</script>

<style scoped>
.no-permission {
  text-align: center;
  margin-top: 50px;
  font-size: 24px;
  color: red;
}
</style>
